import { makeGetRequest, makePostRequest } from './makeRequest';

const getToken = async (code) => {
  try {
    return await makeGetRequest(`api/discord/access_token?code=${code}`);
  } catch (err) {
    throw new Error(err);
  }
};

const getUser = () => makeGetRequest('api/users/self');

const logout = async (code) => {
  try {
    return makePostRequest('api/logout', {});
  } catch (err) {
    throw new Error(err);
  }
}

export { getUser, logout};

export default getToken;
